import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { useDispatch } from 'react-redux';
import { getMemberSalesforceTransactionAnalytics, getSalesforceTransactionAnalytics } from '../redux/slices/account.service';

const TransactionChart = ({ user_type }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false)
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [
      {
        label: 'Transaction Amount',
        data: [],
        backgroundColor: 'rgb(68, 55, 144)',
        borderColor: 'rgb(68, 55, 144)',
        borderWidth: 1,
      },
    ],
  });

  useEffect(() => {

    const fetchData = async () => {
        const action = user_type === 'owner' ? getSalesforceTransactionAnalytics : getMemberSalesforceTransactionAnalytics
        setLoading(true)
        dispatch(action())
        .then((response) => {

            const apiData = response?.payload
            
            // Process the API data for the chart
            const months = apiData.map(item => item.month);
            const amounts = apiData.map(item => item.transaction_amount);
            
              setChartData({
              labels: months,
                  datasets: [
                  {
                      ...chartData.datasets[0],
                      data: amounts,
                  },
                  ],
              });
        })
        .finally(() => setLoading(false))
      
    };

    fetchData();
  }, []);

  return (
    <div style={{ width: '100%'}}>
      <h2>Monthly Transactions</h2>
      <Bar
        data={chartData}
        options={{
          responsive: true,
          plugins: {
            legend: {
              position: 'top',
            },
            title: {
              display: true,
              text: 'Transaction Amount by Month',
            },
          },
          scales: {
            y: {
              beginAtZero: true,
              title: {
                display: true,
                text: 'Amount (N)',
              },
            },
            x: {
              title: {
                display: true,
                text: 'Month',
              },
            },
          },
        }}
      />
    </div>
  );
};

export default TransactionChart;